<template>
	<div>
		<div v-if="parceiroConfig">
			<land-page-slider :parceiro="parceiro" />
			<section :ref="'about'" v-if="parceiroConfig.sessoes.about && parceiroConfig.sessoes.about.campos">
				<land-page-about />
			</section>
			<section :ref="'tutorial'" v-if="parceiroConfig.sessoes.tutorial && parceiroConfig.sessoes.tutorial.campos">
				<land-page-tutorial />
			</section>
			<section :ref="'plans'">
				<land-page-plans />
			</section>
			<section v-if="parceiroConfig.sessoes.partners && parceiroConfig.sessoes.partners.arquivos.length > 0">
				<land-page-partner />
			</section>
			<section :ref="'contact'" v-if="parceiroConfig.sessoes.contact && parceiroConfig.sessoes.contact.campos">
				<land-page-contact />
			</section>
			<land-page-footer />
		</div>
	</div>
</template>

<script>
import LandPageHeader from "./components/LandPageHeader";
import LandPageSlider from "./components/LandPageSlider";
import LandPageAbout from "./components/LandPageAbout";
import LandPageTutorial from "./components/LandPageTutorial";
import LandPagePlans from "./components/LandPagePlans";
import LandPagePartner from "./components/LandPagePartner";
import LandPageContact from "./components/LandPageContact";
import LandPageFooter from "./components/LandPageFooter";
import Vue from "vue";
import Hotjar from "vue-hotjar";
import { mapMutations, mapState, mapActions } from "vuex";
export default {
	name: "Home",
	components: {
		LandPageFooter,
		LandPageContact,
		LandPagePartner,
		LandPageTutorial,
		LandPagePlans,
		LandPageAbout,
		LandPageSlider,
		LandPageHeader
	},
	created() {
		let subdominio = process.env.VUE_APP_STANDARD_PARTNER;
		if (window.location.host.split(".").length > 2) {
			subdominio = window.location.host.split(".")[0] === "hml" || window.location.host.split(".")[0] === "www" ? process.env.VUE_APP_STANDARD_PARTNER : window.location.host.split(".")[0];
		}
		if (subdominio) {
			this.SET_PARCEIRO(null);
			this.SET_LOADING(true);
			this.SET_LOADING_MESSAGE("Carregando o portal");
			this.action_buscar_parceiro({ id: subdominio })
				.then((response) => {
					if (response) {
						this.SET_LOADING_MESSAGE("");
						this.SET_LOADING(false);
						let configParceiro = response.data.data;
						let header = configParceiro.sessoes.find((sessao) => sessao.nome === "header");
						let about = configParceiro.sessoes.find((sessao) => sessao.nome === "about");
						let partners = configParceiro.sessoes.find((sessao) => sessao.nome === "partners");
						let contact = configParceiro.sessoes.find((sessao) => sessao.nome === "contact");
						let tutorial = configParceiro.sessoes.find((sessao) => sessao.nome === "tutorial");
						let logoForBackgroundWhite = configParceiro.sessoes.find((sessao) => sessao.nome === "logoForBackgroundWhite");
						let customization = configParceiro.sessoes.find((sessao) => sessao.nome === "customization");
						let omniChannel = configParceiro.sessoes.find((sessao) => sessao.nome === "omniChannel");

						if (subdominio == "principal") {
							configParceiro.sessoes = {
								header: header,
								about: about,
								partners: partners,
								contact: contact,
								tutorial: tutorial,
								creditor: true,
								logoForBackgroundWhite: logoForBackgroundWhite,
								customization: customization,
								omniChannel: omniChannel
							};
						} else {
							configParceiro.sessoes = {
								header: header,
								about: about,
								partners: partners,
								contact: contact,
								tutorial: tutorial,
								creditor: null,
								logoForBackgroundWhite: logoForBackgroundWhite,
								customization: customization,
								omniChannel: omniChannel
							};
						}
						this.SET_PARCEIRO_CONFIG(configParceiro);

						if (configParceiro?.hotjar_id != null) {
							Vue.use(Hotjar, {
								id: configParceiro?.hotjar_id
							});
						}

						this.SET_PARCEIRO(subdominio);
						this.SET_COR_PRIMARIA({
							"--color": this.parceiroConfig.estilo.corPrimaria,
							"--hovercolor": this.parceiroConfig.estilo.corSecundaria
						});
						this.SET_COR_SECUNDARIA({
							"--color": this.parceiroConfig.estilo.corSecundaria,
							"--hovercolor": this.parceiroConfig.estilo.corPrimaria
						});

						this.action_salvar_etapa({
							esn_fk_ets_codigo: 31,
							emp_codigo: response.data.emp_codigo,
							motivo_agendamento: "Página inicial",
							cpfCnpj: "12341234567"
						});
					} else {
						this.SET_LOADING_MESSAGE("");
						this.SET_LOADING(false);
						this.CHANGE_MESSAGE_MODAL({
							show: true,
							title: "Atenção",
							message: `Subdomínio não encontrado!`,
							styleMessage: "danger"
						});
					}
				})
				.catch((error) => {
					console.log("error", error);

					this.SET_LOADING_MESSAGE("");
					this.SET_LOADING(false);
					this.CHANGE_MESSAGE_MODAL({
						show: true,
						title: "Atenção",
						message: `Subdomínio não encontrado!`,
						styleMessage: "danger"
					});
				});
		}
		window.fbq("trackCustom", "Página inicial");
	},
	methods: {
		...mapActions(["action_buscar_parceiro", "action_salvar_etapa"]),
		...mapMutations(["SET_PARCEIRO", "SET_PARCEIRO_CONFIG", "SET_COR_PRIMARIA", "SET_COR_SECUNDARIA", "SET_LOADING", "SET_LOADING_MESSAGE", "CHANGE_MESSAGE_MODAL"])
	},
	computed: {
		...mapState({
			parceiro: (state) => state.parceiro,
			parceiroConfig: (state) => state.parceiroConfig,
			corPrimaria: (state) => state.corPrimaria,
			corSecundaria: (state) => state.corSecundaria
		})
	}
};
</script>

<style scoped>
.section {
	padding-top: 60px;
	padding-bottom: 60px;
}
</style>
